/**
 * Brand strings rendered by more than one deployable.
 *
 * `apps/marketing` owns the bulk of the marketing copy (see
 * `src/modules/marketing/constants.ts`), but a handful of lines also appear on
 * platform surfaces in `apps/web` - the sign-in shell prints the tagline
 * under the wordmark. Those live here so the two apps cannot drift.
 */
export const TAGLINE = 'Going AI-native.';
